import { useConfigContext } from 'contexts/config';

export const useSo5Competitions = () => {
  const {
    so5: { so5Competitions },
  } = useConfigContext();
  const scoutableSo5Competitions = so5Competitions.filter(
    so5Competition => so5Competition.scoutable
  );
  return {
    so5Competitions,
    scoutableSo5Competitions,
    filterableSo5Competitions: so5Competitions.filter(
      so5Competition => !!so5Competition.algoliaFilters
    ),
  };
};
